<template>
  <div>Redirecting...</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OidcSignIn",
  methods: {
    ...mapActions("brain/auth", ["oidcSigninRedirect"]),
  },
  mounted() {
    // oidc-client-ts does NOT like our #, so we get rid of it before parsing
    // let newLocation = window.location.href.split("#")[1];
    // window.history.replaceState({}, null, newLocation);

    this.oidcSigninRedirect().catch((e) => {
      console.log("oidcSigninRedirect error:", e);
    });
  },
};
</script>
